import React from 'react';
import './EquipmentPopup.css';

function EquipmentPopup({ onClose }) {
  return (
    <div className="equipment-popup-overlay" onClick={onClose}>
      <div className="equipment-popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-button" onClick={onClose} aria-label="Fermer">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>

        <div className="popup-header">
          <h2>Nouveauté : Matériel de sonorisation</h2>
          <p>Complétez votre événement avec notre équipement professionnel</p>
        </div>

        <div className="popup-equipment-grid">
          <div className="popup-equipment-card">
            <div className="popup-equipment-image">
              <img src={require("../img/JBL 710 PNG.webp")} alt="JBL PartyBox 710" />
            </div>
            <h3>JBL PartyBox 710</h3>
            <p className="popup-equipment-price">50€/jour</p>
          </div>

          <div className="popup-equipment-card special">
            <div className="popup-special-badge">Offre spéciale</div>
            <div className="popup-equipment-image">
              <img src={require("../img/Double enceinte JBL 710 PNG.png")} alt="Double JBL 710" />
            </div>
            <h3>Double JBL 710</h3>
            <p className="popup-equipment-price">80€/jour</p>
          </div>

          <div className="popup-equipment-card">
            <div className="popup-equipment-image">
              <img src={require("../img/Smog Machine PNG.png")} alt="Machine à fumée" />
            </div>
            <h3>Machine à fumée</h3>
            <p className="popup-equipment-price">40€/jour</p>
          </div>

          <div className="popup-equipment-card">
            <div className="popup-equipment-image">
              <img src={require("../img/Stroboscope PNG.png")} alt="Stroboscope 1500W" />
            </div>
            <h3>Stroboscope 1500W</h3>
            <p className="popup-equipment-price">20€/jour</p>
          </div>
        </div>

        <div className="popup-cta">
          <a href="/book" className="popup-reserve-button">
            Réserver maintenant
          </a>
        </div>
      </div>
    </div>
  );
}

export default EquipmentPopup;
